import { useInnerModals } from '../../providers';
import { Claim } from '../Claim';

const ClaimModal = () => {
  const { dispatch } = useInnerModals();
  return <Claim onSuccess={() => dispatch(['closeModal'])} />;
};

export { ClaimModal };
